<ng-container *ngIf="initialized">

    <p-dialog
            header="Header"
            [style]="{width: '50vw',height: '600px'}"
            [(visible)]="visible"
            (onHide)="onDialogHide()"
            appendTo="body"
    >
        <ng-template #header>
            <div class="flex justify-content-between align-items-center w-full">
                <span class="font-semibold text-xl">Document</span>
                <p-toggleButton *ngIf="document?.analyzed" [(ngModel)]="toggleDocument"
                                onLabel="HTML View"
                                offLabel="PDF View"></p-toggleButton>
            </div>
        </ng-template>

        <!-- Document HTML View-->
        <ng-container *ngIf="toggleDocument && document.analyzed && formData">
            <app-form-recognizer id="top" [formData]="formData"></app-form-recognizer>
        </ng-container>

        <!-- Document PDF View-->
        <ng-container *ngIf="!toggleDocument || !document.analyzed">
            <object class="w-full h-full" [data]="documentPdfSource" type="application/pdf"
                    *ngIf="this.documentPdfSource">
                <embed [src]="documentPdfSource" type="application/pdf"/>
            </object>
        </ng-container>

    </p-dialog>
</ng-container>
